import { render } from "./PermalinkList.vue?vue&type=template&id=e816090c&ts=true"
import script from "./PermalinkList.vue?vue&type=script&lang=ts"
export * from "./PermalinkList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/waga/Projects/breil/wp-content/themes/breil/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__